export default {
  methods: {
    getEstablecimiento() {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      var identity = JSON.parse(localStorage.getItem("usuario"));
      var idEstablecimiento = app.view.main.router.currentRoute.params.idEstablecimiento;
      var tipoEnvio = "en-el-lugar";
      var url = window.global.url + "establecimientos/" + idEstablecimiento;
      var urlImagen = window.global.url + "imagen/establecimiento/" + idEstablecimiento + "/";
      app.request.getJSON(url, function (data) {
        if (data.status == 'success') {
          // console.log(data);
          let establecimiento = data.establecimiento;
          $('.nombre-establecimiento').text(establecimiento.nombre);

          if (establecimiento.imagen) {
            urlImagen = $('.page[data-name="admin-carta"] .img-establecimiento').attr('src', urlImagen.concat(establecimiento.imagen));
          } else {
            urlImagen = $('.page[data-name="admin-carta"] .img-establecimiento').attr('src', 'static/image-placeholder.png');
          }

          if (establecimiento.mensaje) {
            $('.mensaje-text').html('<p>' + establecimiento.mensaje + '</p>');
          }

          if (establecimiento.direccion && !establecimiento.configuracion.ocultar_direccion) {
            $('.direccion-text').append('<p><i class="icon material-icons md-only">place</i><i class="icon f7-icons ios-only">map_pin</i><a href="https://www.google.com/maps/search/?api=1&query=' + establecimiento.direccion + '" target="_blank" class="item-link item-content link external">' + establecimiento.direccion + '</a></p>');
          }

          if (establecimiento.horarios && !establecimiento.configuracion.ocultar_horarios) {
            $('.horarios-text').append('<p><i class="icon material-icons md-only">schedule</i><i class="icon f7-icons ios-only">clock</i> ' + establecimiento.horarios + '</p>');
          }

          if (tipoEnvio == 'en-el-lugar') {
            $('.en-el-lugar-chip').removeClass('display-none');
          }

          if (tipoEnvio == 'takeaway') {
            $('.takeaway-chip').removeClass('display-none');
          }

          if (tipoEnvio == 'delivery') {
            $('.delivery-chip').removeClass('display-none');
          }

          if (tipoEnvio == 'en-el-lugar' && establecimiento.configuracion.mensaje_en_el_lugar) {
            $('.mensaje-tipoenvio-text').html('<p>' + establecimiento.configuracion.mensaje_en_el_lugar + '</p>');
          }

          if (tipoEnvio == 'takeaway' && establecimiento.configuracion.mensaje_takeaway) {
            $('.mensaje-tipoenvio-text').html('<p>' + establecimiento.configuracion.mensaje_takeaway + '</p>');
          }

          if (tipoEnvio == 'delivery' && establecimiento.configuracion.mensaje_delivery) {
            $('.mensaje-tipoenvio-text').html('<p>' + establecimiento.configuracion.mensaje_delivery + '</p>');
          }

          self.aboutPopUp(data.establecimiento);
          self.getItemsDestacados(data.establecimiento);
          self.getCategorias(data.establecimiento);
        } else {
          app.dialog.alert(data.message);
        }
      }, function (xhr, status) {
        console.log(xhr);
        console.log(status);
        app.dialog.alert("Error establecimiento.");
      });
    },

    aboutPopUp(establecimiento) {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      var urlImagen = "static/wm-logo.png";

      if (establecimiento.imagen) {
        urlImagen = window.global.url + "imagen/establecimiento/" + establecimiento.id_establecimiento + "/" + establecimiento.imagen;
      }

      var popupTemplate = '<div class="popup popup-info">' + '<div class="page">' + '<div class="navbar">' + '<div class="navbar-bg"></div>' + '<div class="navbar-inner">' + '<div class="title">Información</div>' + '<div class="right">' + '<a href="#" class="link popup-close">Cerrar</a>' + '</div>' + '</div>' + '</div>' + '<div class="page-content">' + '<div class="block">' + '<p></p>' + '<div class="text-align-center">' + '<img src="' + urlImagen + '" class="img-establecimiento" alt="">' + '</div>' + '</div>' + '<div class="block text-align-center"><h2>' + establecimiento.nombre + '</h2></div>' + '<div class="list no-hairlines">' + '<ul>' + '<li class="li-info-direccion display-none">' + '<a href="https://www.google.com/maps/search/?api=1&query=' + establecimiento.direccion + '" target="_blank" class="item-link item-content link external">' + '<div class="item-media"><i class="icon material-icons md-only">place</i><i class="icon f7-icons ios-only">map_pin</i></div>' + '<div class="item-inner">' + '<div class="item-title text-color-blue">' + establecimiento.direccion + '</div>' + '</div>' + '</a>' + '</li>' + '<li class="li-info-whatsapp display-none">' + '<a href="https://www.google.com/maps/search/?api=1&query=' + establecimiento.whatsapp + '" target="_blank" class="item-link item-content link external">' + '<div class="item-media"><i class="icon fab fa-whatsapp"></i></div>' + '<div class="item-inner">' + '<div class="item-title text-color-blue">' + establecimiento.whatsapp + '</div>' + '</div>' + '</a>' + '</li>' + '<li class="li-info-telefono display-none">' + '<div class="item-content">' + '<div class="item-media">' + '<i class="icon material-icons md-only">phone</i>' + '<i class="icon f7-icons ios-only">phone</i>' + '</div>' + '<div class="item-inner">' + '<div class="item-title">' + establecimiento.telefono + '</div>' + // '<div class="item-after">CEO</div>' +
      '</div>' + '</div>' + '</li>' + '<li class="li-info-horarios display-none">' + '<div class="item-content">' + '<div class="item-media">' + '<i class="icon material-icons md-only">schedule</i>' + '<i class="icon f7-icons ios-only">clock</i>' + '</div>' + '<div class="item-inner">' + '<div class="item-title" style="--f7-list-item-title-white-space: none;">' + establecimiento.horarios + '</div>' + // '<div class="item-after">CEO</div>' +
      '</div>' + '</div>' + '</li>' + '<li class="li-info-email display-none">' + '<div class="item-content">' + '<div class="item-media">' + '<i class="icon material-icons md-only">mail</i>' + '<i class="icon f7-icons ios-only">envelope</i>' + '</div>' + '<div class="item-inner">' + '<div class="item-title">' + establecimiento.email + '</div>' + // '<div class="item-after">CEO</div>' +
      '</div>' + '</div>' + '</li>' + '<li class="li-info-facebook display-none">' + '<a href="' + establecimiento.facebook + '" target="_blank" class="item-link item-content link external">' + '<div class="item-media"><i class="icon fab fa-facebook md-only"></i><i class="icon f7-icons ios-only">logo_facebook</i></div>' + '<div class="item-inner">' + '<div class="item-title">Facebook</div>' + '</div>' + '</a>' + '</li>' + '<li class="li-info-instagram display-none">' + '<a href="' + establecimiento.instagram + '" target="_blank" class="item-link item-content link external">' + '<div class="item-media"><i class="icon fab fa-instagram md-only"></i><i class="icon f7-icons ios-only">logo_instagram</i></div>' + '<div class="item-inner">' + '<div class="item-title">Instagram</div>' + '</div>' + '</a>' + '</li>' + '</ul>' + '</div>' + '</div>' + '</div>' + '</div>'; // Create dynamic Popup

      var dynamicPopup = app.popup.create({
        content: popupTemplate,
        // Events
        on: {
          open: function (popup) {
            if (establecimiento.direccion || establecimiento.direccion == "") {
              $('.li-info-direccion').removeClass('display-none');
            }

            if (establecimiento.telefono || establecimiento.telefono == "") {
              $('.li-info-telefono').removeClass('display-none');
            }

            if (establecimiento.whatsapp || establecimiento.whatsapp == "") {
              $('.li-info-whatsapp').removeClass('display-none');
            }

            if (establecimiento.horarios || establecimiento.horarios == "") {
              $('.li-info-horarios').removeClass('display-none');
            }

            if (establecimiento.email || establecimiento.email == "") {
              $('.li-info-email').removeClass('display-none');
            }

            if (establecimiento.facebook || establecimiento.facebook == "") {
              $('.li-info-facebook').removeClass('display-none');
            }

            if (establecimiento.instagram || establecimiento.instagram == "") {
              $('.li-info-instagram').removeClass('display-none');
            }
          },
          opened: function (popup) {// console.log('Popup opened');
          }
        }
      }); // Open dynamic popup

      $('.dynamic-popup').on('click', function () {
        dynamicPopup.open();
      });
    },

    getItemsDestacados(establecimiento) {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      var identity = JSON.parse(localStorage.getItem("usuario")); // let establecimiento = JSON.parse(sessionStorage.getItem('_establecimiento'));

      var idEstablecimiento = app.view.main.router.currentRoute.params.idEstablecimiento;
      var url = window.global.url + "items/destacados/establecimiento/" + idEstablecimiento;
      var urlImagen = window.global.url + 'imagen/item/';
      app.request.getJSON(url, function (data) {
        if (data.status == 'success') {
          let cantidad_items_destacados = data.items_destacados.length;
          let slidesPerView = 1;

          if (cantidad_items_destacados > 0) {
            for (var i = 0; i < data.items_destacados.length; i++) {
              // '/menu/'+idEstablecimientoParam+'/categoria/'+idCategoria+'/'+nombreCategoria+'/items/{{id_item}}/{{nombre}}'
              // let urlItem = '/menu/' + idEstablecimiento + '/categoria/' + data.items_destacados[i].id_categoria + '/' + 'null' + '/items/' + data.items_destacados[i].id_item + '/' + data.items_destacados[i].nombre;
              let urlItem = 'item/' + data.items_destacados[i].id_item;
              let itemDestacadoTemplate = '<a href="' + urlItem + '" class="swiper-slide">' + '<div class="swiper-slide" style="background-image:url(' + urlImagen + data.items_destacados[i].id_item + '/' + data.items_destacados[i].imagen + ')">' + '<div class="text-wrap text-shadow padding">' + data.items_destacados[i].nombre + '</div>' + '</div>' + '</a>';

              if (establecimiento.configuracion.ocultar_nombres_productos_destacados) {
                itemDestacadoTemplate = '<a href="' + urlItem + '" class="swiper-slide">' + '<div class="swiper-slide" style="background-image:url(' + urlImagen + data.items_destacados[i].id_item + '/' + data.items_destacados[i].imagen + ')">' + '</div>' + '</a>';
              }

              $('.swiper-destacados').append(itemDestacadoTemplate);
            }

            $('.block-title-destacados').removeClass('display-none');
            $('.swiper-container').removeClass('display-none');

            if (cantidad_items_destacados == 1) {
              slidesPerView = 1;
            } else {
              slidesPerView = 2;
            }

            var swiper = app.swiper.create('.swiper-container', {
              speed: 400,
              spaceBetween: 20,
              slidesPerView: slidesPerView,
              pagination: {
                "el": ".swiper-pagination"
              }
            });
          }
        } else {
          app.dialog.alert(data.message);
        }
      }, function (xhr, status) {
        console.log(xhr);
        console.log(status);
        app.dialog.alert("Error ítems destacados.");
      });
    },

    getCategorias(establecimiento) {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      var identity = JSON.parse(localStorage.getItem("usuario"));
      var idEstablecimiento = app.view.main.router.currentRoute.params.idEstablecimiento;
      var url = window.global.url + "categorias/superiores/habilitadas/establecimiento/" + idEstablecimiento;
      var urlImagen = window.global.url + "imagen/categoria/";
      app.request.json(url, function (response) {
        if (response.code == 200) {
          // let establecimiento = JSON.parse(sessionStorage.getItem('_establecimiento'));
          let categoriaTemplate = '<div class="col-50 large-33 xlarge-25">' + '<a href="categoria/{{id_categoria}}">' + '<div class="card demo-card-header-pic elevation-4" style="background-image:url(' + urlImagen + '{{id_categoria}}/{{imagen}})">' + '<div class="card-header align-items-flex-end">' + '<h3 class="text-shadow">{{nombre}}</h3>' + '</div>' + '</div>' + '</a>' + '</div>';

          if (establecimiento.configuracion.ocultar_nombre_categorias) {
            categoriaTemplate = '<div class="col-50 large-33 xlarge-25">' + '<a href="categoria/{{id_categoria}}">' + '<div class="card demo-card-header-pic elevation-4" style="background-image:url(' + urlImagen + '{{id_categoria}}/{{imagen}})">' + '<div class="card-header align-items-flex-end">' + '</div>' + '</div>' + '</a>' + '</div>';
          }

          if (establecimiento.configuracion.vista_clasica_categorias) {
            categoriaTemplate = '<div class="col-100">' + '<a href="categoria/{{id_categoria}}">' + '<div class="card elevation-4">' + '<div class="card-header align-items-flex-center">' + '<h3 class="text-color-black">{{nombre}}</h3>' + '<div class="item-after">' + '<i class="icon f7-icons text-color-gray">chevron_right</i>' + '</div>' + '</div>' + '</div>' + '</a>' + '</div>';
          }

          var virtualList = app.virtualList.create({
            // List Element
            el: '.vl-categorias',
            createUl: false,
            // Pass array with items
            items: response.categorias,
            // Custom search function for searchbar
            searchAll: function (query, items) {
              var found = [];
              let queryNormalized = query.normalize('NFD').replace(/[\u0300-\u036f]/g, "").normalize().toLowerCase().trim();

              for (var i = 0; i < items.length; i++) {
                if (items[i].nombre.normalize('NFD').replace(/[\u0300-\u036f]/g, "").toLowerCase().indexOf(queryNormalized) >= 0 || query.trim() === '') found.push(i);
              }

              return found; //return array with mathced indexes
            },
            // List item Template7 template
            itemTemplate: categoriaTemplate,
            // Item height
            height: app.theme === 'ios' ? 63 : app.theme === 'md' ? 73 : 46
          });
        }
      });
    }

  },
  on: {
    pageInit() {
      var self = this;
      var app = self.$app;
      var $ = self.$;
      self.getEstablecimiento();
    }

  },
  id: '7e53dae8b9',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '<div class=page data-name=admin-carta><div class=navbar><div class=navbar-bg></div><div class="navbar-inner sliding"><div class=left><a href=# class="link back"><i class="icon icon-back"></i> <span class=if-not-md>Atrás</span></a></div><div class="title nombre-establecimiento"></div><div class=right><a href=# class="link dynamic-popup"><i class="icon material-icons md-only">info</i> <i class="icon f7-icons ios-only">info_circle</i></a></div><div class=subnavbar><form data-search-container=.virtual-list data-search-item=li data-search-in=.item-title class="searchbar searchbar-init"><div class=searchbar-inner><div class=searchbar-input-wrap><input type=search placeholder="Buscar categorías"> <i class=searchbar-icon></i> <span class=input-clear-button></span></div><span class="searchbar-disable-button if-not-aurora">Cancelar</span></div></form></div></div></div><div class=searchbar-backdrop></div><div class=page-content><div class="block text-align-center searchbar-hide-on-search"><img class=img-establecimiento src=""></div><div class="block text-align-center"><div class=mensaje-text></div><div class=direccion-text></div><div class=horarios-text></div><div class="chip en-el-lugar-chip display-none"><div class=chip-label>En el lugar</div></div><div class="chip takeaway-chip display-none"><div class=chip-label>Takeaway</div></div><div class="chip delivery-chip display-none"><div class=chip-label>Delivery</div></div><div class=mensaje-tipoenvio-text></div></div><div class="row justify-content-center"><div class="col-100 medium-100 large-50"><div class="block-title block-title-destacados searchbar-hide-on-search display-none">Destacados</div><div class="swiper-container swiper-items-destacados demo-swiper searchbar-hide-on-search display-none"><div class=swiper-pagination></div><div class="swiper-wrapper swiper-destacados"></div></div><div class=block-title>Categorías</div><div class="list simple-list no-hairlines searchbar-not-found"><ul><li>No hay resultados.</li></ul></div><div class="row virtual-list vl-categorias searchbar-found"></div></div></div></div></div>';
      return r;
    }(this);
  },

  style: `
    .img-establecimiento {
        max-width: 100%;
        max-height: 140px;
    }
`,
  styleScoped: false
};